/**
 *
 * Styles for SaveShipmentButton
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const SaveShipmentWrapper = styled.div`
  ${({ stepperEnabled }) =>
    stepperEnabled &&
    `
        white-space: nowrap;
        @media screen and (max-width: ${breakpoints.tablet}) {
        dhl-button {
            > button {
            width: 100% !important;
            }
        }
        }
    `}
`;
